import { sumUp } from 'utils/array';
import { ClientSinglePackage } from '../../types';
import { invoiceConfigByCode } from '../invoice';
import { packageByStatus } from './status';

export function calculatePackageAmountToBecomeBalance({
  status,
  invoices,
  projects,
}: ClientSinglePackage): number {
  if (!packageByStatus[status].canConvertToBalance) return 0;

  const invoiced = sumUp(
    invoices.map(({ status, value }) =>
      invoiceConfigByCode[status].countToPackageBalanceConversion ? Number(value) : 0,
    ),
  );

  const projectsValue = sumUp(projects.map(({ value }) => Number(value)));

  return invoiced - projectsValue;
}

export function canConvertExceedingPackageValueAsBalance(
  packageData: ClientSinglePackage,
): boolean {
  if (!packageByStatus[packageData.status].canConvertToBalance) return false;

  const hasActiveInvoices = packageData.invoices.some(
    ({ status }) => !invoiceConfigByCode[status].isFinal,
  );

  if (hasActiveInvoices) return false;

  const amountToConvert = calculatePackageAmountToBecomeBalance(packageData);

  const canConvert = !!Number(packageData.amountAvailable) && amountToConvert >= 0;

  return canConvert;
}
